<h2 mat-dialog-title><mat-icon>warning</mat-icon> Admin-Only Contact Warning</h2>
<mat-dialog-content class="mat-dialog-content">
    <p>
        {{data}}
    </p>
</mat-dialog-content>
<mat-dialog-actions class="mat-dialog-actions" id="dialogActions">
    <button [mat-dialog-close]="true" mat-button id="Understood">I Understand</button>
</mat-dialog-actions>
